export const config = {
  title: 'Century 21 of Bless Napo | Realtor',
  meta: {
    description:
      'Century 21 of Bless Napo is your trusted realtor in Missouri, specializing in helping you find your dream home with personalized services and expert guidance.',
    keywords: [
      'Realtor in Missouri',
      'Find Dream Home',
      'Real Estate Services',
      'Bless Napo',
      'Century 21',
    ],
    author: 'Bless Napo',
    canonicalUrl: 'https://www.buywithbless.com/',
  },
  sections: {
    header: {
      businessName: 'Century 21 of Bless Napo | Realtor',
    },
    sectionB: {
      heroTitle: "Century 21 of Bless Napo | Realtor",
      heroSubtitle: "Helping You Find Your Dream Home in Missouri",
      learnAboutText: "Learn About",
      phoneNumber: "6602345328",
      phoneLabel: "(660) 234-5328",
      heroBackgroundImage:
        "https://www.spoliamag.com/wp-content/uploads/2021/07/pexels-curtis-adams-5178047-696x521.jpg",
      cardData: [
        {
          title: "Personalized Service",
          description:
            "Bless ensures a tailored approach that meets your unique needs, making every client feel like their top priority.",
        },
        {
          title: "Flexibility and Availability",
          description:
            "With a deep understanding of busy schedules, Bless accommodates your time, offering seamless scheduling for consultations.",
        },
        {
          title: "Expert Guidance",
          description:
            "With years of experience, Bless’s professional advice helps you buy your dream home or sell for top value.",
        },
      ],
      description:
        "Bless Napo of Century 21 provides comprehensive services to guide you in finding your dream home or selling your property for top value.",
    },
    sectionC: {
      servicesTitle: 'Our Communities',
      servicesDescription:
        'Century 21 of Bless Napo offers expertise in vibrant Missouri communities, helping you explore and find the perfect place to call home.',
      cards: [
        {
          title: 'Kirksville',
          description:
            'Kirksville is the county seat of and most populous city in Adair County, Missouri. Kirksville is home to three colleges: Truman State University, Moberly Area Community College, and A.T. Still University.',
          imageSrc: 'https://moberly.com/wp-content/uploads/edited-0652-1024x576.jpg',
          imageAlt: 'Kirksville Community',
        },
        {
          title: 'Macon',
          description:
            'Macon is a city in and the county seat of Macon County, Missouri, United States. The population was 5,457 at the 2020 census.',
          imageSrc: 'https://images.after55.com/i2/nBm2rO5j7GUHFiAKhwCaCm-M9HQkmdpXeQdEaP6W2A4/112/image.jpg?p=1',
          imageAlt: 'Macon Community',
        },
        {
          title: 'Milan',
          description:
            'Milan is a city in Sullivan County, Missouri, United States. The population was 1,819 at the 2020 census. It is the county seat of Sullivan County.',
          imageSrc:
            'https://bloximages.newyork1.vip.townnews.com/columbiamissourian.com/content/tncms/assets/v3/editorial/9/d9/9d96c1ac-7eac-11ea-8454-d3c8d4283658/5e96552d4fff5.image.jpg?resize=374%2C500',
          imageAlt: 'Milan Community',
        },
      ],
    },
    sectionD: {
      aboutTitle: 'About Us',
      aboutImage: {
        src: 'https://images.marketleader.com/MarketingImages/16/2404216_normal.jpg',
        alt: 'Bless Napo of Century 21 | Realtor',
      },
      aboutText: [
        'Bless Napo of Century 21 is a dedicated realtor in Missouri, offering expert guidance and personalized service to help clients achieve their real estate goals.',
        'With years of experience, Bless provides tailored solutions to make the buying or selling process seamless and stress-free.',
      ],
    },
    sectionE: {
      profileImage: 'null',
      profileAlt: 'Bless Napo Profile Image',
      businessName: 'Bless Napo | Realtor',
      contact: {
        phone: '6602345328',
        phoneLabel: '(660) 234-5328',
        email: 'angiex109@gmail.com',
        website: 'https://www.buywithbless.com/',
        address: '1605 South Baltimore Street, Kirksville, MO 63501',
      },
      socialMedia: {
        googlePlus: null, // If null, falls back to https://mybizsolutions.us/
        linkedIn: null,
        facebook: null,
        twitter: null,
        tiktok: null,
        instagram: null,
        youtube: null,
      },
    },
    sectionF: {
      address: '1605 South Baltimore Street, Kirksville, MO 63501',
      googleMapsEmbedUrl:
        'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2887.5105881886655!2d-92.5800012844882!3d40.19305787918219!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x884039afdf85df3d%3A0x73dc541ee2fae5e0!2s1605%20S%20Baltimore%20St%2C%20Kirksville%2C%20MO%2063501!5e0!3m2!1sen!2sph!4v1614123456789!5m2!1sen!2sph',
    },
  },
};

export default config;
